/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataInfoResVo } from './NodataInfoResVo';
import {
    NodataInfoResVoFromJSON,
    NodataInfoResVoFromJSONTyped,
    NodataInfoResVoToJSON,
    NodataInfoResVoToJSONTyped,
} from './NodataInfoResVo';

/**
 * 
 * @export
 * @interface ResponseNodataInfoResVo
 */
export interface ResponseNodataInfoResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseNodataInfoResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseNodataInfoResVo
     */
    message?: string;
    /**
     * 
     * @type {NodataInfoResVo}
     * @memberof ResponseNodataInfoResVo
     */
    data?: NodataInfoResVo;
}

/**
 * Check if a given object implements the ResponseNodataInfoResVo interface.
 */
export function instanceOfResponseNodataInfoResVo(value: object): value is ResponseNodataInfoResVo {
    return true;
}

export function ResponseNodataInfoResVoFromJSON(json: any): ResponseNodataInfoResVo {
    return ResponseNodataInfoResVoFromJSONTyped(json, false);
}

export function ResponseNodataInfoResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseNodataInfoResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : NodataInfoResVoFromJSON(json['data']),
    };
}

export function ResponseNodataInfoResVoToJSON(json: any): ResponseNodataInfoResVo {
    return ResponseNodataInfoResVoToJSONTyped(json, false);
}

export function ResponseNodataInfoResVoToJSONTyped(value?: ResponseNodataInfoResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': NodataInfoResVoToJSON(value['data']),
    };
}

